<template>
    <div class="checkout-summary">
        <h4 class="block-title">Summary</h4>
        <div class="summary-list" v-if="showItems">
            <div class="summary-block" v-if="bike.amount > 0">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ bike.type_name }} <span v-if="bike.amount > 1" class="text-primary">x{{ bike.amount }}</span></div>
                    <div v-if="bike.discount && !promoCode" class="summary-block-item-value has-discount">
                        <span class="old-price">{{ (bike.price * bike.amount) | filterPrice }}</span><br>
                        {{ (bike.final_price * bike.amount) | filterPrice }}
                    </div>
                    <div v-else class="summary-block-item-value" >
                        {{ (bike.price * bike.amount) | filterPrice }}
                    </div>
                </div>
            </div>
            <div class="summary-block" v-for="item in bikesCart.filter(i => i.amount > 0)">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ item.type_name }} <span v-if="item.amount > 1" class="text-primary">x{{ item.amount }}</span></div>
                    <div v-if="item.discount && !promoCode" class="summary-block-item-value has-discount">
                        <span class="old-price">{{ (item.price * item.amount) | filterPrice }}</span><br>
                        {{ (item.final_price * item.amount) | filterPrice }}
                    </div>
                    <div v-else class="summary-block-item-value" >
                        {{ (item.price * item.amount) | filterPrice }}
                    </div>
                </div>
            </div>
        </div>
        <div class="summary-total">
            <div class="summary-block">
                <div class="summary-block-item secondary-item">
                    <div class="summary-block-item-title">Subtotal</div>
                    <div class="summary-block-item-value">{{ (showItems ? getTotal : 0) | filterPrice }}</div>
                </div>
                <div class="summary-block-item secondary-item">
                    <div class="summary-block-item-title">Tax</div>
                    <div class="summary-block-item-value">{{ totalTax | filterPrice }}</div>
                </div>
                <div class="summary-block-item secondary-item" v-if="surgeCharge > 0">
                    <div class="summary-block-item-title">Surge charge</div>
                    <div class="summary-block-item-value">{{ surgeCharge | filterPrice }}</div>
                </div>
                <div class="summary-block-item colored-item">
                    <div class="summary-block-item-title">Total</div>
                    <div class="summary-block-item-value">{{ (showItems ? (getTotal + totalTax - totalDiscount + surgeCharge) : 0) | filterPrice }}</div>
                </div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ApiRequest from "../../../../utils/api-request";

export default {
    name: "CheckoutSummaryRental",
    props: {
        showAndClear: {
            type: Boolean,
            default: false
        },
        bikesCart: {
            type: Array
        },
        bike: {
            type: Object
        },
        showItems: {
            type: Boolean
        },
        tax: {
            default: 0
        },
        currentLocation: {
            type: Object,
            default: () => null
        },
        isUpdate: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            savedCartState: {},
            ready: false,
            total: 0
        }
    },
    computed: {
        getTotal: function () {
            const bikes = this.bikesCart.filter(i => i.amount > 0);
            const bike = this.bike.discount && !this.promoCode
                ? (this.bike.final_price * this.bike.amount)
                : (this.bike.price * this.bike.amount)

            return bikes.reduce((acc, i) => acc + (i.final_price * i.amount), 0) + bike;
        },
        bikes: function () {
            return this.showAndClear ? this.savedCartState.bikes : this.$store.getters['cart/bikes']
        },
        events: function () {
            return this.showAndClear ? this.savedCartState.events : this.$store.getters['cart/events']
        },
        tours: function () {
            return this.showAndClear ? this.savedCartState.tours : this.$store.getters['cart/tours']
        },
        accessories: function () {
            return this.showAndClear ? this.savedCartState.accessories : this.$store.getters['cart/accessories']
        },
        merchandises: function () {
            return this.showAndClear ? this.savedCartState.merchandises : this.$store.getters['cart/merchandises']
        },
        additionalOptions: function () {
            return this.showAndClear ? this.savedCartState.additionalOptions : this.$store.getters['cart/additionalOptions']
        },
        totalTax: function () {
            return this.showItems ? Math.ceil(this.getTotal * (this.tax / 100)) : 0
        },
        isEmpty: function () {
            return this.showAndClear ? this.savedCartState.isEmpty : this.$store.getters['cart/isEmpty']
        },
        promoCode: function () {
            return this.showAndClear ? this.savedCartState.promoCode : this.$store.getters['cart/promoCode']
        },
        totalDiscount: function () {
            return this.showAndClear ? this.savedCartState.totalDiscount : this.$store.getters['cart/totalDiscount']
        },
        surgeCharge: function () {
            // const locations = this.$store.getters['app/locations'];
            // let surge_charge = 0;
            //
            // if(this.currentLocation) {
            //     const location = locations.find(location => location.id === this.currentLocation.id);
            //     surge_charge = location.surge_charge !== undefined ? parseInt(location.surge_charge) : 0;
            // }
            //
            // if(this.bike && this.bike.amount !== undefined) {
            //     return surge_charge * this.bike.amount;
            // }
            return 0;
        },
    },
    mounted() {
        this.cloneCartState();
        if (this.showAndClear) {
            this.$store.dispatch('cart/clear');
        }
    },
    methods: {
        ...mapActions('cart', ['clearPromoCode']),
        cloneCartState() {
            this.savedCartState = {
                bikes: this.$store.getters['cart/bikes'],
                events: this.$store.getters['cart/events'],
                tours: this.$store.getters['cart/tours'],
                accessories: this.$store.getters['cart/accessories'],
                merchandises: this.$store.getters['cart/merchandises'],
                additionalOptions: this.$store.getters['cart/additionalOptions'],
                totalPrice: this.$store.getters['cart/totalPrice'],
                totalTax: this.$store.getters['cart/totalTax'],
                isEmpty: this.$store.getters['cart/isEmpty'],
                promoCode: this.$store.getters['cart/promoCode'],
                totalDiscount: this.$store.getters['cart/totalDiscount']
            }
        }
    }
}
</script>

<style scoped>

</style>
